export default {
  disasterAvoidPolygons: {
    name: 'Name',
    description: 'Description',
    disasterType: 'Disaster type',
    disasterSubType: 'Disaster subtype',
    fillRequiredFields: 'Please fill the required fields for the disaster area',
    avoidAreaSaved: 'Disaster area saved',
    avoidAreaDeleted: 'Disaster area deleted',
    fillAreaProperties: 'Fill the avoid area properties and save it',
    editProperties: 'Edit properties',
    createADisasterPolygon: 'Create a disaster polygon',
    createADisasterRectangle: 'Create a disaster rectangle',
    errorWhileTryingToSaveDisasterArea: 'Error while trying to save disaster area',
    authorizationError: 'Authorization error. Please make sure the key you entered is valid. To enter the key again reload the app',
    disasterAreaUsageInfo: 'You can: move the map view to load disaster areas of a target region, use the polygon drawing tools to create new disaster areas and click on a disaster area to edit it',
    errorCodes: {
      2404: 'Provider does not exist',
      3404: 'Disaster type does not exist',
      5409: 'Disaster area name already in use'
    },
    statuses: {
      401: 'Unauthorized',
    }
  }
}
